import { render } from "./StandardCodeView.vue?vue&type=template&id=fef1af8a"
import script from "./StandardCodeView.vue?vue&type=script&lang=js"
export * from "./StandardCodeView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__